import TelemedicineRequestCompleteView from './TelemedicineRequestCompleteView';

export { TelemedicineRequestCompleteView };
